<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>{{ $t("headers.vehicles") }}</h3>
                <router-link
                    v-if="$store.getters.hasGatehousePerm('add_vehicleentry')"
                    :to="{ name: 'vehicleEntryAddView' }"
                    class="btn btn-sm btn-success me-3 d-inline-flex align-items-center"
                >
                    <icon icon="Plus" class="me-2"></icon>
                    <span class="fs-6 fw-bold">{{ $t("utils.addRecord") }}</span>
                </router-link>

            </div>
            <div class="card-body">
                <div class="row mb-5 align-items-end">
                    <div class="col-12 col-md-3">
                        <label class="form-label fw-bold">
                            {{ $t("vehicleEntry.licencePlate") }}
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="filters.licence_plate"
                            :placeholder="$t('vehicleEntry.licencePlate')"
                        />
                    </div>

                    <div class="col-12 col-md-3">
                        <label class="form-label fw-bold">
                            {{ $t("vehicleEntry.carrier") }}
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="filters.carrier"
                            :placeholder="$t('vehicleEntry.carrier')"
                        />
                    </div>

                    <div class="col-12 col-md-2">
                        <label class="form-label fw-bold">
                            {{ $t("vehicleEntry.from") }}
                        </label>
                        <input
                            type="date"
                            class="form-control"
                            v-model="filters.expected_from"
                        />
                    </div>

                    <div class="col-12 col-md-2">
                        <label class="form-label fw-bold">
                            {{ $t("vehicleEntry.to") }}
                        </label>
                        <input
                            type="date"
                            class="form-control"
                            v-model="filters.expected_to"
                        />
                    </div>

                    <div class="col-12 col-md-2 d-flex">
                        <button
                            class="btn btn-secondary w-100"
                            @click="resetFilters"
                        >
                            {{ $t("utils.clearFilters") }}
                        </button>
                    </div>
                </div>

                <VehicleEntryProvider
                    :api-url="`/${$route.params.slug}/vehicle-entries`"
                    :filters="filters"
                    v-slot="p"
                >
                    <VehicleEntryTable
                        :items="p.items"
                        :total-count="p.totalCount"
                        :page="p.page"
                        :per-page="p.perPage"
                        @page-change="p.setPage"
                        @per-page-change="p.setPerPage"
                        @refresh="() => p.refresh()"
                    />
                </VehicleEntryProvider>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import VehicleEntryTable from '@/components/VehicleEntryTable.vue';
import VehicleEntryProvider from '@/components/VehicleEntryProvider.vue';

    export default {
        components: {
            Icon,
            VehicleEntryTable,
            VehicleEntryProvider,
        },
        data() {
            return {
                filters: {
                    licence_plate: "",
                    carrier: "",
                    expected_from: "",
                    expected_to: "",
                }
            }
        },
        methods: {
            resetFilters() {
                this.filters.licence_plate = "";
                this.filters.carrier = "";
                this.filters.expected_from = "";
                this.filters.expected_to = "";
            },
        }
    }
</script>